import { createFileRoute } from "@tanstack/react-router";

import {
  BlogListing,
  buildListingHead,
  pageCount,
  pageSlice,
} from "../components/blog/BlogListing";
import { guardPage } from "../components/blog/BlogCategoryPage";
import { posts } from "../content/blog";
import { BLOG_DESCRIPTION, BLOG_H1, BLOG_INTRO, blogGraphNode } from "./blog.index";

const BASE_PATH = "/blog";

function head(page: number) {
  return buildListingHead({
    title: `Блог HAY.agency — страница ${page}`,
    description: `${BLOG_DESCRIPTION} Страница ${page} из ${pageCount(posts.length)}.`,
    path: `${BASE_PATH}/page/${page}`,
    basePath: BASE_PATH,
    page,
    totalPages: pageCount(posts.length),
    items: pageSlice(posts, page),
    breadcrumbs: [
      ["Главная", "/"],
      ["Блог", "/blog"],
      [`Страница ${page}`, `${BASE_PATH}/page/${page}`],
    ],
    extraGraph: [blogGraphNode],
  });
}

export const Route = createFileRoute("/blog/page/$page")({
  loader: ({ params }) => ({ page: guardPage(BASE_PATH, params.page, pageCount(posts.length)) }),
  head: ({ loaderData }) => head(loaderData?.page ?? 2),
  component: BlogPageRoute,
});

function BlogPageRoute() {
  const { page } = Route.useLoaderData();
  return (
    <BlogListing
      h1={`${BLOG_H1} — страница ${page}`}
      intro={BLOG_INTRO}
      items={pageSlice(posts, page)}
      page={page}
      totalPages={pageCount(posts.length)}
      basePath={BASE_PATH}
      breadcrumbCurrent={`Страница ${page}`}
      featureFirst={false}
    />
  );
}
